import { isDefined } from "@prismicio/editor-support/Type"

import type { WidgetExtension } from "../models"
import {
  ExtendedRichTextNodeType,
  isExtendedRichTextNodeTypeSet,
} from "../types"
import { default as Bold } from "./Bold/Bold"
import { default as BulletList } from "./BulletList/BulletList"
import { default as CodeBlock } from "./CodeBlock/CodeBlock"
import { default as Embed } from "./Embed/EmbedExtension"
import { default as Heading } from "./Heading/Heading"
import { default as Image } from "./Image/ImageExtension"
import { default as Italic } from "./Italic/Italic"
import { Label } from "./Label/Label"
import { Link } from "./Link/Link"
import { default as OrderedList } from "./OrderedList/OrderedList"
import { default as Paragraph } from "./Paragraph/Paragraph"
import { Table } from "./Table/Table"

const BaseExtensions = [Bold, Italic, Link]
export const MarkExtensions = [...BaseExtensions, Label]
export type MarkExtensionName = (typeof MarkExtensions)[number]["name"]

export function getAllExtensions(
  nodeTypes?: Set<ExtendedRichTextNodeType>,
): WidgetExtension[] {
  if (isExtendedRichTextNodeTypeSet(nodeTypes)) {
    return [...BaseExtensions, Paragraph, Table].filter(isDefined)
  }

  return [
    Paragraph,
    BulletList,
    OrderedList,
    Heading.build(nodeTypes),
    CodeBlock,
    Embed,
    Image,
    ...MarkExtensions,
  ].filter(isDefined)
}

export {
  Bold,
  BulletList,
  CodeBlock,
  Embed,
  Heading,
  Image,
  Italic,
  Label,
  Link,
  OrderedList,
  Paragraph,
  Table,
}
